import { SubmissionStatuses } from '../types';

/** Total used as the denominator for percentage = (count / total) * 100 */
const TOTAL_SUBMISSIONS = 1000;

export const SUBMISSION_STATUSES_MOCK: SubmissionStatuses = {
  total_submissions: TOTAL_SUBMISSIONS,
  statuses: [
    {
      ordinal: 1,
      status: 'Draft',
      count: 5,
      percentage: (5 / TOTAL_SUBMISSIONS) * 100,
    },
    {
      ordinal: 2,
      status: 'Pre-Review',
      count: 495,
      percentage: (495 / TOTAL_SUBMISSIONS) * 100,
    },
    {
      ordinal: 3,
      status: 'Review',
      count: 500,
      percentage: (500 / TOTAL_SUBMISSIONS) * 100,
    },
  ],
};
